import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store.js';
import * as Sentry from '@sentry/react';
import { filterSentryEvent } from './utils/sentryFilters';

if (import.meta.env.VITE_APP_ENV == 'prod') {
  Sentry.init({
    dsn: 'https://e843e8b029217ad2b9def445afd1bd13@o4507628518178816.ingest.us.sentry.io/4507628546621440',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Drop reviewed, non-actionable client errors before they are sent to Sentry.
    beforeSend: filterSentryEvent,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/client\.laundrycare\.biz\//,
      /^https:\/\/client\.pushlaundry\.com\//,
      'http://127.0.0.1:5173/',
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
  // </React.StrictMode>
);
